import { ComponentChildren } from "preact";
import { useState } from "preact/hooks";
import { provideReactiveLayer } from "fluidstate";
import { getReactiveLayer } from "fluidstate-preact/reactive-layer";
import { injectGlobal } from "../common/css";
import assetAveriaFont from "../assets/averia-gruesa-libre-regular.ttf";
import { mainTheme } from "../common/theme";

provideReactiveLayer(getReactiveLayer());

injectGlobal`
	html, body, div, span, applet, object, iframe,
	h1, h2, h3, h4, h5, h6, p, blockquote, pre,
	a, abbr, acronym, address, big, cite, code,
	del, dfn, em, img, ins, kbd, q, s, samp,
	small, strike, strong, sub, sup, tt, var,
	b, u, i, center,
	dl, dt, dd, ol, ul, li,
	fieldset, form, label, legend,
	table, caption, tbody, tfoot, thead, tr, th, td,
	article, aside, canvas, details, embed, 
	figure, figcaption, footer, header, hgroup, 
	menu, nav, output, ruby, section, summary,
	time, mark, audio, video {
		margin: 0;
		padding: 0;
		border: 0;
		font-size: 100%;
		font: inherit;
		vertical-align: baseline;
	}
	article, aside, details, figcaption, figure, 
	footer, header, hgroup, menu, nav, section {
		display: block;
	}
	ol, ul {
		list-style: none;
	}
	blockquote, q {
		quotes: none;
	}
	blockquote:before, blockquote:after,
	q:before, q:after {
		content: '';
		content: none;
	}
	table {
		border-collapse: collapse;
		border-spacing: 0;
	}
	*,
	*::before,
	*::after {
		box-sizing: border-box;
	}
	@font-face {
		font-family: 'Averia Gruesa Libre';
		font-style: normal;
		font-weight: 400;
		font-display: swap;
		src: url(${assetAveriaFont});
	}
	:root {
		color-scheme: dark;
	}
	body {
		color: ${mainTheme.mainTextColor};
		line-height: 1.6;
		background-color: ${mainTheme.mainBackgroundColor};
		font-family: sans-serif;
		font-size: 17px;
	}
`;

let setContent: (content: ComponentChildren) => void;

export const setAppContent = (content: ComponentChildren) => {
	setContent(content);
};

export const App = ({ children }: { children: ComponentChildren }) => {
	let contentHandle = useState(children);
	setContent = contentHandle[1];
	return <>{contentHandle[0]}</>;
};
